import React from "react";
import { ReactComponent as ReactLogo } from './../logo.svg';


function ReactWelcome() {
    const bgClr = {'backgroundColor': '#282c34', 'color': 'white', 'padding': '20px'}
    return (
        <div style={bgClr}>
            {/* Refer svg file from src dir */}
            {/* <img src={logo} className="App-logo" alt="logo" />   */}
            
            {/* Refer svg file from public dir */}
            {/* <img src="/react_logo.svg" className="App-logo" alt="react_logo" /> */}
            
            {/* Import svg as a Component */}
            {/* <ReactLogo style={{ height: 200 }} /> */}

            <ReactLogo style={{ height: 200 }} />

            <p>
            Edit <code>src/App.js</code> and save to reload.
            </p>

            <a
            className="App-link"
            href="https://reactjs.org"
            target="_blank"
            rel="noopener noreferrer"
            >
            Learn React
            </a>

            <h1>Sellers Bids Portal</h1>
        </div>
    )
}

export default ReactWelcome;
